import React from 'react';

export default function Circle(props) {
  return (
    <svg height={22} width={22} {...props}>
      <circle cx={11} cy={11} r={7} fill="black" />
    </svg>
  );
}
